const path = {
    managerBlocks: '/propinas/manager/blocks',
    forgetBlock: '/propinas/manager/blocks/'
}

export { path }